<template>
  <div>
    <div class="abnormal">
      <img src="../assets/Abnormal.png">
      <p>系统维护中</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "abnormal"
  }
</script>

<style scoped>
  .abnormal {
    width: 100%;
    height: 100%;
    text-align: center;
    margin-top: 20vh;
  }

  p {
    font-weight: bolder;
    font-size: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Abnormal.vue